﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'products-view',
    template: '#products-view-template',
    data: () => ({

    }),
    props: ['product', 'index'],
    computed:
        Object.assign(
            mapState({
                address: state => state.offeringpage.addresslookup.selectedAddress,
                allProducts: state => state.offeringpage.products.available,
                isDoneSearching: state => state.offeringpage.products.isDoneSearching,
                selectedVariantCode: state => state.offeringpage.products.selectedVariant,
                selectedNumberOfVas: state => state.offeringpage.products.selectedNumberOfVas
            }),
            mapGetters({
                otherProducts: 'otherProducts',
                otherVariants: 'otherVariants',
                selectedProduct: 'selectedProduct',
                selectedVariant: 'selectedVariant',
                selectedVas: 'selectedVas'
            }),
            {                
                numberOfVas() {
                    return this.selectedVariant.numberOfVas;
                },
                isRecommended() {
                    return this.selectedVariant.isRecommended;
                },
                isTeliaHomeFree() {
                    return this.selectedVariant.isTeliaHomeFree;
                },
                hasPickedVas() {
                    return (this.selectedVas && this.selectedVas.length > 0);
                },
                iconUrl() {
                  if (!this.product) return '';                  
                  if (this.product.code == 'LLF') return '/UI/ECommerce/images/ico-fiber.png';
                  if (this.product.code == 'LLN') return '/UI/ECommerce/images/ico-coax.png';
                  if (this.product.code == 'LLD') return '/UI/ECommerce/images/ico-dsl.png';
                  if (this.product.code == 'MBB2') return '/UI/ECommerce/images/ico-mbb.png';

                    return '';
                },
                ewiiIconUrl() {
                  //return '/UI/ECommerce/images/svg/ico-ewii.svg#icon';
                  return '/UI/ECommerce/images/ico-ewii.png';

                },
                isSelectedProduct() {
                    return this.product.code == this.selectedProduct.code;
                },
                speed() {
                    if (this.product.code == 'MBB2') return this.item.speedDown;
                    return this.item.speedDown + "/" + this.item.speedUp;
                }
            }
        ),
        methods: {
            selectVariant(installationFeeCode, activationFeeCode, paymentFeeCode, productCode, variantCode, selectedNumberOfVas, vendor) {
                this.$store.dispatch('selectVariant', { installationFeeCode: installationFeeCode, activationFeeCode: activationFeeCode, paymentFeeCode: paymentFeeCode, productCode: productCode, variantCode: variantCode, numberOfVas: selectedNumberOfVas, vendor: vendor });
                this.$emit('select', 'This can be w/e');
            },
            variantSpeed(productCode, itemSpeedDown, itemSpeedUp) {
                if (productCode == 'MBB2') return itemSpeedDown;
                return itemSpeedDown + "/" + itemSpeedUp;
            },
            isSelectedVariant(code) {
                return code == this.selectedVariantCode;
            },
            vendorIconUrl(vendor) {
                if (vendor === 'Ewii')
                    return '/UI/ECommerce/images/svg/ico-ewii.svg#icon';
                return '';
            },
        }, 
        mounted: function() {
            
        }
}
